<template>
    <div id="agent-list-component">
        <div class="animated fadeIn">
            <div class="row">
                <b-table stacked="md" id="my-table" striped hover :fields="fields" :busy="isBusy" :items="pagination.data">
                    <template #cell(agente)="data">
                        {{ data.item.comisionista }}
                    </template>
                    <template #cell(e-mail)="data">
                        {{ data.item.reluser.email }}
                    </template>
                    <template #cell(usuario)="data">
                        {{ data.item.reluser.username }}
                    </template>
                </b-table>
            </div>
        </div>
    </div>
</template>
<script>
import {myMixins} from "../mixins/myMixins";
import {agentsService} from "../../Services/Agents.service";

export default {
    name: 'agents-for-promoter',
    props: {
        promoter_id: {
            type: Number,
            required: false
        }
    },
    mixins: [myMixins],
    data() {
        return {
            modificar: false,
            isBusy: false,
            fields: [
                {key: 'agente', sortable: false},
                {key: 'e-mail', sortable: false},
                {key: 'usuario', sortable: false},
            ],
            pagination: {
                current_page: 1,
                data: [],
                first_page_url: '',
                from: 0,
                last_page: 0,
                last_page_url: '',
                links: [],
                next_page_url: '',
                path: '',
                per_page: 0,
                prev_page_url: '',
                to: 0,
                total: 0,
            },
            params: {
                limit: 10,
                page: 1,
                where: [{
                    field: 'promoter_id',
                    operator: '=',
                    value: this.promoter_id,
                }],
            },
            tituloBtn: '',
        }
    },
    methods: {
        async index() {
            this.pagination = await agentsService.getMany(this.params);
        },
    },
    mounted() {
        this.index();
    }
}
</script>
